/*
 *             Copyright (c) 2016 - 2023, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x3f69=['compress','shift','push','_operationName','types','decompress'];(function(_0xb17a49,_0x3f69bc){var _0x449e0e=function(_0x3dca3f){while(--_0x3dca3f){_0xb17a49['push'](_0xb17a49['shift']());}};_0x449e0e(++_0x3f69bc);}(_0x3f69,0x92));var _0x449e=function(_0xb17a49,_0x3f69bc){_0xb17a49=_0xb17a49-0x0;var _0x449e0e=_0x3f69[_0xb17a49];return _0x449e0e;};import _0x2e7d80 from'./operationcompressor';export default class p extends _0x2e7d80{[_0x449e('0x4')](_0x107966,_0x25dc90){return _0x25dc90['shift'](),_0x107966[_0x449e('0x2')][_0x449e('0x0')](this['_id']),!0x0;}[_0x449e('0x3')](_0x5d97f2,_0x391bfc){_0x391bfc['types'][_0x449e('0x5')](),_0x5d97f2[_0x449e('0x0')]({'__className':this[_0x449e('0x1')]});}}